module.exports = __webpack_public_path__ + "img/CardBack.0c724885.png";